module.exports = __webpack_public_path__ + "static/banner01-9bdb3c89032fdb9d51243b3eb8dd2bc6.png";